// Third-party
import React from 'react';

// Utils
import { FormattedMessage } from '../../../../utils/i18n';

// Types
import Locale from '@/types/locale';

interface Props {
  asterisk?: boolean;
  block?: boolean;
  disclaimerKey: string;
  sectionKey?: string;
  locale?: Locale;
}

const DefaultDisclaimer = ({ asterisk, block, disclaimerKey, locale, sectionKey }: Props) => {
  let ariaId = 'disclaimer';
  disclaimerKey && (ariaId += `-${disclaimerKey}`);
  sectionKey && (ariaId += `-${sectionKey}`);

  return (
    <div className="disclaimer" id={ariaId} role="note" style={{ display: block ? 'block' : 'inline' }} data-private data-dd-privacy="mask">
      {asterisk && <sup className="disclaimer-marker">*</sup>}
      <FormattedMessage id={`Disclaimers.${disclaimerKey}`} locale={locale} />
    </div>
  );
};

export default DefaultDisclaimer;
